import { Component, Inject, Optional } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "mat-dialog",
  templateUrl: "./dialog.template.html",
  styleUrls: ["./dialog.style.scss"]
})
export class DialogComponent {
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.data = data;
  }
}
